import { render, staticRenderFns } from "./comp_OrderSummary-Item.vue?vue&type=template&id=0c6c337e&scoped=true&"
import script from "./comp_OrderSummary-Item.vue?vue&type=script&lang=js&"
export * from "./comp_OrderSummary-Item.vue?vue&type=script&lang=js&"
import style0 from "./comp_OrderSummary-Item.vue?vue&type=style&index=0&id=0c6c337e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6c337e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
